import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "listen",
  "use": "listen-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"listen\"><path fill=\"currentColor\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0m-1 0A7 7 0 1 0 2 9a7 7 0 0 0 14 0m-8.5 3.5a.5.5 0 0 0 .3-.1l4-3a.5.5 0 0 0 0-.8l-4-3A.5.5 0 0 0 7 6v6a.5.5 0 0 0 .5.5M8 11l2.667-2L8 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol